import Vue from 'vue';
import Vuex from 'vuex';
import {decrypt, encrypt} from '@/util/encrypt';
import client from '@/store/client';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    client
  },
  state: {
    socketChannel: '',
    user: null,
  },
  getters: {
    getUser: (state) => {
      const value = JSON.parse(decrypt(localStorage.getItem('oanda-user-admin-am')));
      return value
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
      localStorage.setItem('oanda-user-admin-am', encrypt(JSON.stringify(payload)));
    },
  },
  actions: {
    loadUser(action) {
      try {
        const value = JSON.parse(decrypt(localStorage.getItem('oanda-user-admin-am')));
        if (value) {
          action.commit('setUser', value);
        }
      } catch (e) {
      }
    }
  },
});
